import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import DesService from "../Services/Des Service";
const LogOut = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  console.log();
  useEffect(() => {
    let params = {
      token: localStorage.getItem("token"),
    };

    DesService.userLogout(params)
      .then(() => {
        localStorage.clear();

        Swal.fire({
          text: "You have Successfully Logged Out",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(() => {
          navigate("/Login");
        });
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          localStorage.clear();
          navigate("/Login");
        } else {
          console.error(error);
        }
      });
  }, []);

  return <></>;
};
export default LogOut;
